export default __webpack_public_path__ + "static/media/STATREP- Moses Einstein Wakefield.6b7cc8eb.pdf";